export default __webpack_public_path__ + "static/media/miguel-lopes-32.17eb1638.jpg";